module.exports = __webpack_public_path__ + "a8fb8845d0bd9cd43e7a07f6e67e8ffe.png";